import { Link } from 'react-router-dom';
import { ArrowRightIcon, CameraIcon } from 'lucide-react';
import { useSignedInAccount } from '../../../contexts/AccountContext';
import { useSite } from '../../../contexts/SiteContext';
import { daysSince, diaryWeek, today } from '../../../utils/account';
import { plural } from '../../../core/format/text';

/** Herinnert aan een nieuwe foto als de laatste lang genoeg geleden is. */
export function DiaryTeaser() {
  const {
    policy
  } = useSite();
  const {
    account
  } = useSignedInAccount();
  const sorted = [...account.diary].sort((a, b) => a.date.localeCompare(b.date));
  const first = sorted[0];
  const last = sorted[sorted.length - 1];
  const due = !last || daysSince(last.date) >= policy.diaryEveryDays;
  const week = diaryWeek(first?.date, today());
  const title = !last ? 'Begin je fotodagboek' : due ? `Tijd voor je foto van week ${week}` : 'Fotodagboek';
  const body = !last ? 'Eén foto vandaag, dan zie je over een paar maanden precies wat er veranderd is. Alleen voor jou.' : due ? 'Zelfde raam, zelfde licht, geen make-up. Over een paar maanden ben je blij dat je hem hebt.' : sorted.length > 1 ? `${plural(sorted.length, 'foto', 'foto’s')} sinds de start. Vergelijk ze naast elkaar.` : 'Je eerste foto staat erin. Over een paar weken maak je de volgende.';
  return <section aria-labelledby="diary-title" className="bg-shell p-5 ring-1 ring-line sm:p-6" data-id="element-6113" data-mp="2riugfnpxr92b">
      <div className="flex items-start gap-4" data-id="element-6114" data-mp="35i3zcv5j0h9z">
        {/* Foto's zijn hier sfeer; de echte vergelijking staat op de dagboekpagina. */}
        {first && last && first.id !== last.id ? <div className="flex shrink-0 -space-x-3" aria-hidden="true" data-id="element-6115" data-mp="3f86rkt4tpr79">
            {[first, last].map(e => <img key={e.id} src={e.image} alt="" className="h-16 w-12 object-cover ring-2 ring-shell" data-id="element-6116" data-mp="3aancxs47rces" />)}
          </div> : first ? <img src={first.image} alt="" className="h-16 w-12 shrink-0 object-cover" data-id="element-6117" data-mp="3jb3aym26trc9" /> : <span className="flex h-16 w-12 shrink-0 items-center justify-center bg-sand text-muted" aria-hidden="true" data-id="element-6118" data-mp="2gxnk1ztkwd3q">
            <CameraIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-6119" data-mp="2lxjscb9b6qp3" />
          </span>}
        <div className="min-w-0 flex-1" data-id="element-6120" data-mp="2pxtx5kld7b2d">
          <div className="flex items-start justify-between gap-3" data-id="element-6121" data-mp="2pwsk5aksgei0">
            <h2 id="diary-title" className="text-[15px] text-ink" data-id="element-6122" data-mp="2upu2xto48y6v">
              {title}
            </h2>
            {last && <Link to="/account/dagboek" aria-label="Bekijk je hele fotodagboek" className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-[13px] text-muted transition-colors duration-150 ease-soft hover:text-ink" data-id="element-6123" data-mp="2znn9wox8tw87">
                Bekijk alles
                <ArrowRightIcon className="h-3.5 w-3.5" strokeWidth={1.5} aria-hidden="true" data-id="element-6124" data-mp="1f81qh9rcyu1s" />
              </Link>}
          </div>
          <p className="mt-1 text-[14px] leading-relaxed text-muted" data-id="element-6125" data-mp="1jaolfjjbsv37">{body}</p>
          <Link to={due ? '/account/dagboek?nieuw=1' : '/account/dagboek'} className="mt-3 inline-flex items-center gap-1.5 text-[14px] text-clay underline-offset-4 transition-colors duration-150 ease-soft hover:text-ink hover:underline" data-id="element-6126" data-mp="1bqnuhje24z6v">
            <CameraIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-6127" data-mp="xypqfmz7dthk" />
            {due ? 'Foto toevoegen' : 'Bekijk je voortgang'}
          </Link>
        </div>
      </div>
    </section>;
}